import { membershipHasPermission, Permission } from '@insio/shared-types';
import { useAuth } from '../context';
import type { UserRole } from '@/graphql';

export interface UsePermissionsReturn {
  /** Returns true when the current user has the given permission. */
  hasPermission: (permission: Permission) => boolean;
  canExportInvoice: boolean;
}

/**
 * Checks business-level permissions for the currently authenticated user.
 * Reads the same role map the backend guard does, so the UI cannot offer — or hide — an action
 * the server would decide differently.
 */
export function usePermissions(): UsePermissionsReturn {
  const { user } = useAuth();
  const roles = (user?.roles ?? []) as UserRole[];
  const source = user?.source;

  const hasPermission = (permission: Permission) =>
    membershipHasPermission(roles, source, permission);
  const canExportInvoice = hasPermission(Permission.INVOICES_EXPORT);

  return { hasPermission, canExportInvoice };
}
